module.exports = __webpack_public_path__ + "img/app_android.d3b66ab1.png";